const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { BROKER_CUSTOM_WALLET_CONFIGURATION_URL, MYPROFILE_BROKER_EXPLORE_URL } = require('constants/index');

class brokerMyInvestmentsContractsEmptyStates extends React.Component {

    render() {
        const { immMyWalletCharts } = this.props;

        let primaryText = "broker-myInvestmentsContractsEmptyCustomView";
        if (immMyWalletCharts.get('isGeneralViewSelected')) {
            primaryText = "broker-myInvestmentsContractsEmptyGeneralView";
        }

        const buyLink = (
            <OKLink
                modifier="emphasize"
                extraClass="broker-my-investments-contracts__configuration-link"
                to={MYPROFILE_BROKER_EXPLORE_URL} >
                <FormattedText
                    value="broker-myInvestmentsBuyValues"
                />
            </OKLink>
        );

        const customWalletConfiguration = (
            <OKLink
                modifier="emphasize"
                extraClass="broker-my-investments-contracts__configuration-link"
                to={BROKER_CUSTOM_WALLET_CONFIGURATION_URL}>
                <FormattedText value="broker-customWalletConfiguration" />
            </OKLink>
        );

        const primaryTextWithComponents = (
            <div className="broker-my-investments-contracts-empty-state__text">
                <div>
                    {formatText('broker-myInvestmentsContractsEmpty')}
                </div>
                <FormattedTextWithComponents
                    value={primaryText}
                    injectedComponents={[buyLink, customWalletConfiguration]}
                />
            </div>
        );

        return (
            <EmptyState
                secondaryText={primaryTextWithComponents}
                iconType="noitems-wealth" />
        );
    }
}

brokerMyInvestmentsContractsEmptyStates.propTypes = {
    immMyWalletCharts: PropTypes.object
};

module.exports = brokerMyInvestmentsContractsEmptyStates;
